import React from 'react';
import StyledTextField from './PinnacleTextField.styled';
import { PinnacleTextFieldProps } from './PinnacleTextField.types';

const PinnacleTextField: React.FC<PinnacleTextFieldProps> = (props) => {
  return <StyledTextField {...props} />;
};

export default PinnacleTextField;
